import type { ToggleEvalResult, TogglesDefinitions } from './types'

export const EXPIRATION_TIME_IN_MILLIS = 15 * 60 * 1000
export const REQUEST_TIMEOUT_IN_MILLIS = 20 * 1000

/**
 *
 * Perform a normalization of the evaluated toggles, in order to expose only the
 * resulting toggle value, to simplify the usage of the toggles in the application.
 *
 */
export const normalizeEvaluatedToggles = (
  evaluatedToggles: ToggleEvalResult
): TogglesDefinitions => {
  const normalizedToggles = Object.keys(evaluatedToggles).reduce(
    (acc, key) => {
      acc[key] = evaluatedToggles[key].variation
      return acc
    },
    {} as Record<string, unknown>
  )
  return normalizedToggles as TogglesDefinitions
}
